import { EmptyBlockDeprecated, ShoppingCartIcon } from '@ag1/ui';
import { useLocale } from '@portal/shared/hooks/useLocale';
import { useQueryGetOrdersV2 } from '@portal/state/internal/getOrders';
import { useQueryGetCommonContentData } from '@portal/state/studio/commonContentData/getCommonContentData';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMedia } from 'state/context/MediaContext';
import { routes } from '../../../constants/routes';
import style from './Home.module.scss';

export const EmptyState = () => {
  const locale = useLocale();
  const { t } = useTranslation('subscriptionList');
  const { atSmall } = useMedia();
  const { data: orders = [] } = useQueryGetOrdersV2();
  const [isOTP, setIsOTP] = useState(false);

  const { title, text, button } = t('emptyState', { returnObjects: true });
  const { data: commonContent } = useQueryGetCommonContentData({ locale }) || {};
  const { noPurchaseTitle, noPurchaseText, otpTitle, otpText } = commonContent?.emptyState || {};

  useEffect(() => {
    if (orders && orders.length > 0) {
      for (let i = 0; i < orders.length; i += 1) {
        // if every order doesn't have a subscription_custom_name then it's an OTP
        if (orders[i].subscription_custom_name) {
          setIsOTP(false);
          return;
        }
      }
      setIsOTP(true);
    }
  }, [orders, setIsOTP]);

  const displayedContent = isOTP
    ? { title: otpTitle, text: otpText }
    : { title: noPurchaseTitle, text: noPurchaseText };

  return (
    <div className={style.emptyBlock}>
      <EmptyBlockDeprecated
        icon={<ShoppingCartIcon strokeWidth={atSmall ? 0.6 : 1.5} />}
        title={displayedContent.title || title}
        text={displayedContent.text || text}
        btnName={button}
        externalHref={routes.offers}
        onClick={() => null}
        btnSize={{ s: 'large', xxs: 'medium' }}
        size={{ s: 'desktop', xxs: 'mobile' }}
      />
    </div>
  );
};
